/// <reference path="../../../../../../typings/index.d.ts" />
/// <reference path="../../basicEmailMarketing.module.ts" />

module Meevo.Plugins.BasicEmailMarketing {
    interface ITypeAheadOptions {
        template: string;
        itemModelKey: string;
        categoryModelKey: string;
        anyCategory: boolean;
        anyItem: boolean;
        includeInactive?: boolean;
        includeDiscontinued?: boolean;
    }

    class PurchasedANotBComponent implements ng.IComponentController {
        static $inject = [
            '$scope'
        ];

        //#region bindings
        public purchasedANotBModel: IPurchasedANotB;
        public clientSelectionId: BasicMarketingClientSelectionEnum;
        public onChange: () => {};
        public disabled: boolean;
        //#endregion bindings

        public aOptions: ITypeAheadOptions;
        public bOptions: ITypeAheadOptions;
        public excludeNotItems: string[] = null;
        public excludeItems: string[] = null;
        public includeInactiveServices: boolean;
        public includeDiscontinuedProducts: boolean;

        constructor(private $scope: ng.IScope) {
            this.aOptions = {
                template: null,
                itemModelKey: null,
                categoryModelKey: null,
                anyCategory: null,
                anyItem: null,
            };
            this.bOptions = {
                template: null,
                itemModelKey: null,
                categoryModelKey: null,
                anyCategory: null,
                anyItem: null,
            };

            this.setWatchers();
        }

        public modelAChanged() {
            this.excludeNotItems = null;

            if (this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsPurchasedServiceAnotServiceB ||
                this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsPurchasedProductAnotProductB) {
                this.excludeNotItems = this.purchasedANotBModel[this.aOptions.itemModelKey] ? [this.purchasedANotBModel[this.aOptions.itemModelKey].id] : null;
            }

            this.onChange();
        }

        public modelBChanged() {
            this.excludeItems = null;

            if (this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsPurchasedServiceAnotServiceB ||
                this.clientSelectionId === BasicMarketingClientSelectionEnum.ClientsPurchasedProductAnotProductB) {
                this.excludeItems = this.purchasedANotBModel[this.bOptions.itemModelKey] ? [this.purchasedANotBModel[this.bOptions.itemModelKey].id] : null;
            }

            this.onChange();
        }

        private setWatchers(): void {
            this.$scope.$watch(() => this.clientSelectionId, (newValue, oldValue) => {
                switch (this.clientSelectionId) {
                    case BasicMarketingClientSelectionEnum.ClientsPurchasedServiceAnotServiceB:
                        this.aOptions = {
                            template: 'service',
                            itemModelKey: 'service',
                            categoryModelKey: 'serviceCategory',
                            anyCategory: true,
                            anyItem: true,
                        };
                        this.bOptions = {
                            template: 'service',
                            itemModelKey: 'notService',
                            categoryModelKey: 'notServiceCategory',
                            anyCategory: false,
                            anyItem: true,
                        };
                        break;
                    case BasicMarketingClientSelectionEnum.ClientsPurchasedProductAnotProductB:
                        this.aOptions = {
                            template: 'product',
                            itemModelKey: 'product',
                            categoryModelKey: 'productCategory',
                            anyCategory: true,
                            anyItem: true,
                        };
                        this.bOptions = {
                            template: 'product',
                            itemModelKey: 'notProduct',
                            categoryModelKey: 'notProductCategory',
                            anyCategory: false,
                            anyItem: true,
                        };
                        break;
                    case BasicMarketingClientSelectionEnum.ClientsPurchasedServiceNotProduct:
                        this.aOptions = {
                            template: 'service',
                            itemModelKey: 'service',
                            categoryModelKey: 'serviceCategory',
                            anyCategory: true,
                            anyItem: true,
                        };
                        this.bOptions = {
                            template: 'product',
                            itemModelKey: 'notProduct',
                            categoryModelKey: 'notProductCategory',
                            anyCategory: true,
                            anyItem: true,
                        };
                        break;
                }
            });
        }
    }

    angular.module('meevo.plugins.basicEmailMarketing')
        .component('meevoPurchasedANotBComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/basicEmailMarketing/components/purchased-a-not-b/purchased-a-not-b.template.html',
            controller: PurchasedANotBComponent,
            controllerAs: '$ctrl',
            bindings: {
                purchasedANotBModel: '=',
                clientSelectionId: '=',
                onChange: '&',
                disabled: '=?ngDisabled',
                includeInactiveServices: '=',
                includeDiscontinuedProducts: '='
            }
        });
}
